// CustomCarousel.js
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./../component_styles/CustomCarousel.css";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";

function CustomCarousel({ scrollToQuickAccess }) {
  const navigate = useNavigate();
  const { width, height } = useWindowDimensions();
  const isSmallDevice = width < 768;

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 215000,
  };

  const smallSettings = {
    ...settings,
    dots: false,
    arrows: false,
  };

  const sliderSettings = isSmallDevice ? smallSettings : settings;

  if (isSmallDevice) {
    return (
      <div className="phone-landing">
        <div className="flex flex-row grid-cols-2 justify-center items-center px-4 py-8">
          {/* Text column */}
          <div className="slide-content-small flex-1 pr-4 text-black">
            <h2 className="text-2xl font-light mb-2">Welcome to</h2>
            <h1 className="text-3xl font-bold mb-4">
              Thompson Square Pharmacy
            </h1>
            <p className="mb-6">
              At Thompson Square Pharmacy, we've got you covered from all
              angles. Explore our full range of services.
            </p>
            <button
              className="p-3 bg-gray-600 hover:bg-white hover:text-gray-700 text-white border border-black rounded"
              onClick={scrollToQuickAccess}
            >
              Learn More
            </button>
          </div>

          {/* Image column */}
          <div className="flex-1 pl-4">
            <img
              src="/assets/phone-hero.png"
              alt="Hero"
              className="w-full h-auto max-w-xs mx-auto"
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carousel-container">
      <Slider {...sliderSettings}>
        {/* Slide 2 */}
        <div className="carousel-slide slide-2">
          <img
            className="slide-img"
            src="./assets/banner2lighter.png"
            alt="Banner 2"
          />
          {width < 651 || height < 691 ? (
            <div className="slide-content-small">
              <h2>Welcome to</h2>
              <h1>Thompson Square Pharmacy</h1>
              <p>
                At Thompson Square Pharmacy, we've got you covered from all
                angles. Check out all our services.
              </p>
              <button
                style={{ backgroundColor: "white", color: "black" }}
                onClick={scrollToQuickAccess}
              >
                Learn More
              </button>
            </div>
          ) : (
            <div className="slide-content">
              <h2>Welcome to</h2>
              <h1>Thompson Square Pharmacy</h1>
              <p>
                At Thompson Square Pharmacy, we've got you covered from all
                angles. Check out all our services.
              </p>
              <button
                style={{ backgroundColor: "white", color: "black" }}
                onClick={scrollToQuickAccess}
              >
                Learn More
              </button>
            </div>
          )}
        </div>

        {/* Slide 1 */}
        <div className="carousel-slide slide-1">
          <img
            className="slide-img"
            src="./assets/banner1lighter.png"
            alt="Banner 1"
          />
          <div
            className={
              width < 651 || height < 691
                ? "slide-content-small"
                : "slide-content"
            }
          >
            <h2>RX REFILLS & TRANSFERS</h2>
            {width > 922 ? (
              <p>
                At Thompson Square Pharmacy, we make managing your medications
                easy. Whether you need a refill on your current prescription or
                want to transfer a prescription from another pharmacy, we’re
                here to help. Our friendly staff will assist you every step of
                the way.
              </p>
            ) : (
              width > 650 && (
                <p>
                  At Thompson Square Pharmacy, we make managing your medications
                  easy. Whether you need a refill on your current prescription
                  or want to transfer a prescription from another pharmacy,
                  we’re here.
                </p>
              )
            )}
            <button
              className={
                width >= 1008 ? "button-primary" : "button-primary-small"
              }
              onClick={() => navigate("/prescription")}
            >
              Submit Refill
            </button>
            <button
              className="bg-gray-500 text-white"
              onClick={() => navigate("/prescription")}
            >
              Transfer Prescription
            </button>
          </div>
        </div>

        {/* Slide 3 - Vaccination */}
        <div className="carousel-slide slide-3">
          <img
            className="slide-img"
            src="./assets/banner3lighter.png"
            alt="Banner 3"
          />
          <div
            className={
              width < 651 || height < 691
                ? "slide-content-small"
                : "slide-content"
            }
          >
            <h2>QUICK & EASY VACCINATION</h2>
            {width > 922 ? (
              <p>
                Did you know pharmacists in Ontario can vaccinate? Our
                pharmacists at Thompson Square Pharmacy are certified and ready
                to help you stay protected. Whether you need a flu shot or other
                immunizations, we offer safe and convenient vaccination services
                to keep you healthy.
              </p>
            ) : (
              width > 650 && (
                <p>
                  At Thompson Square Pharmacy, we make managing your medications
                  easy. Whether you need a refill on your current prescription
                  or want to transfer a prescription from another pharmacy,
                  we’re here.
                </p>
              )
            )}
            <button
              className="bg-gray-500 text-white"
              onClick={() => navigate("/vaccination")}
            >
              Request an Appointment Now
            </button>
          </div>
        </div>
      </Slider>
    </div>
  );
}

export default CustomCarousel;
